import AxiosInstance from "@/components/Axios"
import { getErrorMessage } from "@/interfaces/error_types";
import { AxiosError, AxiosResponse } from "axios";

/** TODO: I really don't want this anymore */
 
// Base API response
export interface APIResponse<T = void> {
    operation: "COMPLETED" | "ERROR" // Whether the operation was completed successfully or not
    status: number
    message: string
    data: T
}

// Interface for the params.
// Can either be for queries or as the data for the request
export interface Params {
    [key: string]: string | number | boolean | object | Date
}

export class API {
    // We can have multiple callers in case we need to switch out Axios for something else
    private static Caller = AxiosInstance

    // Add an abort controller to the request for later

    static async get<T>(url: string, params?: Params): Promise<APIResponse<T>> {
        try {
            const response = await API.Caller.get<T>(url, { params: params })
            return await API.processResponse(response)
        } catch (error) {
            return API.processError(error)
        }
    }
    static async post<T>(url: string, data?: Params): Promise<APIResponse<T>> {
        try {
            const response = await API.Caller.post(url, data)
            return await API.processResponse(response)
        } catch (error) {
            return API.processError(error)
        }
    }
    static async put<T>(url: string, data?: Params): Promise<APIResponse<T>> {
        try {
            const response = await API.Caller.put(url, data)
            return await API.processResponse(response)
        } catch (error) {
            return API.processError(error)
        }
    }
    static async delete<T>(url: string): Promise<APIResponse<T>> {
        try {
            const response = await API.Caller.delete(url)
            return await API.processResponse(response)
        } catch (error) {
            return API.processError(error)
        }
    }

    // Process the response for all except get requests
    private static async processResponse<T>(response: AxiosResponse<T>): Promise<APIResponse<T>> {
        if (response.status >= 200 && response.status < 300) {
            return {
                operation: "COMPLETED",
                status: response.status,
                message: response.statusText,
                data: response.data,
            }
        }

        // Error response from the server
        return {
            operation: "ERROR",
            status: response.status,
            message: response.statusText,
            data: {} as T
        }
    }

    private static processError<T>(error: unknown): APIResponse<T> {
        if (error instanceof AxiosError) {
            return {
                operation: "ERROR",
                status: error.response?.status || 500,
                message: error.response?.data || getErrorMessage(error.response?.status || 500),
                data: error.response?.data
            }
        } else if (error instanceof Error) {
            return {
                operation: "ERROR",
                status: 500,
                message: error.message,
                data: {"error": error.message} as T
            }
        }
        // Something went wrong with the request
        return {
            operation: "ERROR",
            status: 500,
            message: "Internal Server Error",
            data: {} as T
        }
    }

    // todo: Make a retry request

    // todo: have an abort controller for the request
}